import store from "../store";
import roles from "./roles";

export default {
  computed: {
    isContractManager: function () {
      return store.getters.isAuthorized(roles.contractManager);
    },
    isContractViewer: function () {
      return store.getters.isAuthorized(roles.contractViewer);
    },

    isOpportunitiesManager: function () {
      return store.getters.isAuthorized(roles.opportunitiesManager);
    },
    isOpportunitiesViewer: function () {
      return store.getters.isAuthorized(roles.opportunitiesViewer);
    },
    isSitesViewer: function () {
      return store.getters.isAuthorized(roles.sitesViewer);
    },
    isSitesManager: function () {
      return store.getters.isAuthorized(roles.sitesManager);
    },
    isStudentPlacementsManager: function () {
      return store.getters.isAuthorized(roles.studentPlacementsManager);
    },
    isTranslationalTeam: function () {
      return store.getters.isAuthorized(roles.translationalTeam);
    },
    isImpersonation: function () {
      return store.getters.isAuthorized(roles.impersonation);
    }
  }
};
